// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__zgV4K","footer":"ModalError_footer__2EA5k"};